import { useTheme } from "next-themes"
import * as React from "react"
import { SVGProps } from "react"

const XIcon = (props: SVGProps<SVGSVGElement>) => {
    const { theme } = useTheme()
    const isDark = theme === "dark"

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={28}
            height={28}
            fill="none"
            {...props}>
            <path
                fill={isDark ? "#ffffff" : "#000000"}
                d="m5.044 4.5 6.95 9.928L5 22.5h1.574l6.123-7.067 4.947 7.067H23l-7.34-10.486L22.168 4.5h-1.574l-5.639 6.509L10.4 4.5H5.044Zm2.315 1.239h2.46L20.685 21.26h-2.46L7.357 5.74Z"
            />
        </svg>
    )
}

export default XIcon
